import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1f179211")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.crosshair)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: "line h",
        style: {left: `${_ctx.crosshair ? _ctx.crosshair.x : 0}px`}
      }, null, 4))
    : _createCommentVNode("", true)
})